<template>
  <div class="input-wrap" v-bind="null">
    <div v-if="label || max" class="input-label">
      <label v-if="label">{{label}}<span v-if="req" class="input-label-req"> *</span><slot name="tooltip" /></label>
      <div v-if="max && showCounter" class="input-counter">{{model ? model.length : 0}}/{{max}}</div>
    </div>
<!--    theme id 'default' or 'new-mode'-->
    <div :class="['input-control', inpType && `type-${inpType}`, theme + '-theme']">
      <input v-if="inpType === 'input'"
        :class="[{error, 'valid': isValid}, inputClass, iconClass && 'input-icon']"
        v-bind="$attrs"
        :name="name"
        :maxlength="max"
        :autocomplete="autocomplete"
        v-model="model"
        :type="type"
        @paste="$emit('paste', $event)"
        @blur="v?.$touch()"
        @input="v?.$touch()" />
      <textarea
        v-else
        :class="[{error, 'valid': isValid}, inputClass, iconClass && 'input-icon']"
        v-bind="$attrs"
        :name="name"
        :maxlength="max"
        v-model="model"
        @blur="v?.$touch()"
        @input="v?.$touch()" />
      <i v-if="customIconClass" :key="customIconClass" :class="[customIconClass, 'custom-icon']"/>
      <i v-if="iconClass" :key="iconClass" :class="[iconClass, 'validate-icon']" />
      <i v-if="clearable && !!model" @click.stop="onClear" :class="['clearable-icon', 'fak fa-xmark-regular']" />
    </div>
    <error-message :custom-error="customError" :name="name" :v="v" :server-error="serverError"/>
  </div>
</template>
<script>
import Vue from 'vue'
import ErrorMessage from "@/components/__new_ui_kit/ErrorMessage/ErrorMessage";
export default Vue.extend({
  components: {ErrorMessage},

  props: {
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: 'text'
    },
    theme: {
      type: String,
      default: 'default'
    },
    inpType: {
      type: String,
      default: 'input'
    },
    value: {
      type: String,
      default: ""
    },
    max: {
      type: Number,
      default: undefined
    },
    req: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    showValidateIcons: {
      // true, false, 'error', 'valid'
      type: [Boolean, String],
      default: false
    },
    showCounter: {
      type: Boolean,
      default: true
    },
    customIconClass: {
      type: String,
      default: null
    },
    inputClass: {
      type: String,
    },
    serverError: {
      type: String,
      default: ""
    },
    customError: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    // либо так, либо реализовать inject/provide
    v: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        if (this.$props.max && this.$props.max < value?.length) return
        this.$emit('input', value)
      }
    },
    iconClass() {
      // todo -> вариант, если надо сразу отметить без ожидания dirty
      if ((this.showValidateIcons === true && this.v?.$dirty) || !!this.serverError) {
        if (this.v?.$error || this.error) return 'fak fa-circle-exclamation-solid val-error'
        return 'fak fa-circle-check-solid val-success'
      }
      else if (this.showValidateIcons === 'error') {
        if (this.v?.$error || this.error) return 'fak fa-circle-exclamation-solid val-error'
        return null
      }
      else if (this.showValidateIcons === 'valid') {
        if (!this.v?.$error || this.error) return 'fak fa-circle-check-solid val-success'
        return null
      } else return null
    },
    isValid() {
      return (this.showValidateIcons === true || this.showValidateIcons === 'valid') && !this.v?.$error && this.v?.$dirty && !this.error
    }
  },
  methods: {
    onClear() {
      if (this.$listeners['on-clear']) this.$emit('on-clear')
      else this.model = ""
    }
  }
})
</script>
<style lang="scss" scoped>;
.input-wrap {
  min-width: 150px;
  width: 100%;
  // not sure about it...
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .input-label {
    font-family: Segoe UI, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    &-req {
      color: $color-red;
    }
    label {
      color: $color-main-text;
    }
    .input-counter {
      color: $color-secondary-text;
    }
  }
  .input-control {
    &.type-input {
      height: 40px;
      .validate-icon, .custom-icon, .clearable-icon {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &.type-textarea {
      min-height: 100px;
      .validate-icon, .custom-icon, .clearable-icon {
        top: 10px
      }
      textarea {
        min-height: 100px;
        &::-webkit-resizer {
          background-image: url('~@/assets/resizer-textarea.svg');
          background-repeat: no-repeat;
          background-position: center;
        }
        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-corner {
          border-radius: 6px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 6px;
        }
      }
    }
    position: relative;
    input,textarea {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      padding: 10px 16px;
      background-color: white;
      font-family: Segoe UI, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      border: 1px solid $color-gray-light-2;
      color: $color-main-text;
      &:disabled {
        color: $color-secondary-text;
        border: 1px solid $color-gray-light-2;
        background-color: $color-gray-light;
      }
      &:focus {
        border: 1px solid #7DABEF;
        box-shadow: 0 0 4px 0 #86B7FE;
        &::placeholder {
          color: transparent;
        }
      }
      &::placeholder {
        color: $color-secondary-text
      }
      &.error {
        border-color: $color-red;
        background-color: $color-red-light;
      }
      &.valid {
        background-color: $color-blue-light;
      }
      &.input-icon {
        padding-right: 32px;
      }
    }
    input {
      transition: 0.2s ease-in;
    }
    textarea {
      transition: all 0.2s ease-in, height 0s;
    }
    .validate-icon, .custom-icon, .clearable-icon {
      cursor: pointer;
      position: absolute;
      right: 13px;
      &.val-error {
        color: $color-red;
      }
      &.val-success {
        color: $color-blue;
      }
    }
    .clearable-icon {
      font-size: 12px;
      color: $color-main-text;
    }
    .custom-icon ~ .clearable-icon {
      right: 32px
    }
    .validate-icon ~ .clearable-icon {
      right: 32px
    }
    .custom-icon {
      color: $color-main-text;
    }
  }


  .input-control.new-mode-theme {
    &.type-input {
      height: auto;
      .validate-icon, .custom-icon, .clearable-icon {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &.type-textarea {
      min-height: 100px;
      .validate-icon, .custom-icon, .clearable-icon {
        top: 10px
      }
      textarea {
        min-height: 100px;
        &::-webkit-resizer {
          background-image: url('~@/assets/resizer-textarea.svg');
          background-repeat: no-repeat;
          background-position: center;
        }
        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-corner {
          border-radius: 6px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 6px;
        }
      }
    }
    position: relative;
    input,textarea {
      padding: 20px;
      border-radius: 8px;
      background: #fff;
      border: 1px solid #e0e2e7;
      width: 100%;
      height: 100%;
      font-family: 'Levenim MT', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: $color-main-text;
      &:disabled {
        color: $color-secondary-text;
        border: 1px solid $color-gray-light-2;
        background-color: $color-gray-light;
      }
      &:focus {
        border: 1px solid #a3a3a5;
        box-shadow: none;
        background: #fff;
      }
      &::placeholder {
        color: #a3a3a5;
        font-family: 'Levenim MT', sans-serif;
      }
      &.error {
        border-color: $color-red;
        background-color: $color-red-light;
      }
      &.valid {
        background-color: #fff;
      }
      &.input-icon {
        padding-right: 32px;
      }
    }
    input {
      transition: 0.2s ease-in;
    }
    textarea {
      transition: all 0.2s ease-in, height 0s;
    }
    .validate-icon, .custom-icon, .clearable-icon {
      cursor: pointer;
      position: absolute;
      right: 13px;
      &.val-error {
        color: $color-red;
      }
      &.val-success {
        color: $color-blue;
      }
    }
    .clearable-icon {
      font-size: 12px;
      color: $color-main-text;
    }
    .custom-icon ~ .clearable-icon {
      right: 32px
    }
    .validate-icon ~ .clearable-icon {
      right: 32px
    }
    .custom-icon {
      color: $color-main-text;
    }
  }
}
</style>